/**
 * Globales Popup-Fenster für Besucher, die zum ersten Mal auf die Seite kommen.
 */
const initGlobalPopup = () => {
  const popup = document.querySelector('.js-global-popup');

  if (!popup) {
    return;
  }

  const openPopup = () => {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  };

  const closePopup = () => {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  };

  // Popup nach kurzer Verzögerung anzeigen
  setTimeout(openPopup, 1500);

  // Schließen-Button
  const closeButton = popup.querySelector('.js-global-popup-close');

  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  // Popup schließen, wenn außerhalb des Inhalts geklickt wird
  popup.addEventListener('click', (event) => {
    if (event.target === popup) {
      closePopup();
    }
  });
};

export default initGlobalPopup;